<template>
  <div class="profile-wrapper">
    <div class="profile-img-wrap">
      <div class="profile-img-grp">
        <!-- 사용자 선택 이미지 -->
        <div class="img-grp" @click="handleClick">
          <img
            src="@/assets/images/img/img_profile.webp"
            alt="이미지"
            class="img"
          />
        </div>

        <!-- 선택 이미지 없을 경우 디폴트 이미지 -->
        <!-- <div class="img-grp">
          <img
            src="@/assets/images/img/img_profile.svg"
            alt="이미지"
            class="img type-default"
          >
        </div> -->
      </div>
      <!-- TODO: 수정 아이콘 필요 시 사용 / 디폴트 false -->
      <div :class="{ 'is-show': proModify }" class="profile-modify-icon">
        <i class="icon icon-modify" />
      </div>
    </div>
    <p class="img-txt f-rem15 f-m f-bk">프로필 사진</p>
  </div>
</template>

<script>
export default {
  name: "ProfileImg",
  props: {
    proModify: {
      // 수정 아이콘
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit("trigger-file-input");
    },
  },
};
</script>
